export const BORDER_STYLE = '1px solid'
export const BORDER_COLOR = 'divider'

export const COLORS = [
	"#44e0a8", "#ff4953", "#26aaff", "#fdba36", "#a161fe", "#f571f0", "#45b9d9", "#e76f3e", "#9f42a3", "#5bc8a0", "#ff7f00", "#4c4c4c", "#d1a82c", "#007b5f", "#ff9aa2",
	"#6a67ce", "#c259b6", "#3eaf76", "#ffaa4c", "#0087bd"
]